import { Injectable } from '@angular/core';

import { Router } from '@angular/router';

import { BehaviorSubject, interval, map, Observable, of, Subject } from 'rxjs';

import { AccountService } from './account.service';
import { Title } from '@angular/platform-browser';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({

  providedIn: 'root',

})

export class OtherService {

  dataObserver: BehaviorSubject<any> = new BehaviorSubject(null);

  oservableSource: any;

  private isUserLogin: BehaviorSubject<boolean> = new BehaviorSubject(!!this.userModel().strSession);

  isUserLogin$ = this.isUserLogin.asObservable();

  private isUserSelectedCity: BehaviorSubject<boolean> = new BehaviorSubject(!!this.get_defaultCity().strCityName)

  isUserSelectedCity$ = this.isUserSelectedCity.asObservable();

  private isChat_: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isChat_$ = this.isChat_.asObservable();

  private hasBaseInfo: BehaviorSubject<boolean> = new BehaviorSubject(!!this.getApp_Config());

  hasBaseInfo$ = this.hasBaseInfo.asObservable();

  constructor(private router: Router, private accountService: AccountService, private _tabTitle: Title) {

    this.oservableSource = this.dataObserver.asObservable();

    this.changeUserLogin_Status(!!this.userModel().strSession);

  }

  getBase64(file) {

    var reader = new FileReader();
    var result;
    reader.readAsDataURL(file);
    reader.onload = () => {
      result = reader.result;
      this.dataObserver.next(result);

    };
    reader.onerror = function (error) {
      // console.log('Error: ', error);
    };

  }

  showSpinner() {
    var sp = document.getElementById("loading") as any;
    sp.classList.remove("d-none");
  }

  hideSpinner() {
    var sp = document.getElementById("loading") as any;
    sp.classList.add("d-none");
  }

  changeUserLogin_Status(type: boolean) {

    this.isUserLogin.next(type)

  }

  changeUserSelectedCity_Status(type: boolean) {

    this.isUserSelectedCity.next(type)

  }

  changeChat_Status(type: boolean) {

    this.isChat_.next(type)

  }

  changeUserInfo_Status(type: boolean) {

    this.hasBaseInfo.next(type)

  }

  logout() {

    var selectedCity = this.get_defaultCity();

    window.localStorage.clear();

    this.changeUserLogin_Status(false);

    localStorage.setItem('dc30al1i7rez0ab02', this.accountService.encrypt(JSON.stringify(selectedCity)));

  }

  getLocalStorage() {

    if (localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')) {

      var item = JSON.parse(this.accountService.decrypt(localStorage.getItem('db30a17f18d1a8a3l0ifr4z8ab0b02')!))

      return item;

    }

    else return {}

  }

  getApp_Config() {

    const encryptedData = localStorage.getItem('XDid7TYzRFD');

    if (encryptedData) {

      try {

        const decryptedData = this.accountService.decrypt(encryptedData);

        return JSON.parse(JSON.parse(decryptedData));

      }

      catch (error) {

        console.error('Error decrypting:', error);

      }

    }

  }

  get_PartnerData() {

    if (localStorage.getItem('db31a17f18d1a8a3l0ifrEz8abJb02')) {

      var item = JSON.parse(this.accountService.decrypt(localStorage.getItem('db31a17f18d1a8a3l0ifrEz8abJb02')!))

      return item;

    }

    else return {}

  }

  get_defaultCity() {

    if (localStorage.getItem('dc30al1i7rez0ab02')) {

      var item = JSON.parse(this.accountService.decrypt(localStorage.getItem('dc30al1i7rez0ab02')!))

      return item;

    }

    else return {}

  }

  getAbility() {

    var item = localStorage.getItem('ability');

    return JSON.parse(item);

  }

  userModel() {

    var model = this.getLocalStorage();
    // console.log(model);

    var data = {
      iTaxiLon_User: model.Id,
      strSession: model.session,
    };
    return data;
  }

  basicModel() {

    var model = this.getLocalStorage();

    var data = {

      strVillageCode: model.VilageCode,

      strCityCode: model.CityCode,

    };

    return data;
  }

  fullModel() {
    var model = this.getLocalStorage();
    var data = {
      strVillageCode: model.VilageCode,
      strCityCode: model.CityCode,
      iUserManager_User: model.Id,
      strSession: model.session,
    };
    return data;
  }

  // takes an object and convert string that contain number to number and return it 

  stringNumberToNumber(obj: any): any {

    const allowedWord = ['i', 'ti', 'f', 'd'];

    for (const key in obj) {

      if (typeof obj[key] === 'string' && !isNaN(parseFloat(obj[key]))) {

        for (const word of allowedWord) {

          if (key.startsWith(word)) {

            obj[key] = parseFloat(obj[key]);

            break; // Exit inner loop once a match is found

          }

        }

      }

      else if (obj[key] === 'true') {

        obj[key] = true;

      }

      else if (obj[key] === 'false') {

        obj[key] = false;

      }

    }

    return obj;
  }

  initialFilterValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    // console.log(strKey);
    // console.log(strKeyValue);
    // console.log(strComment);

    if (!strKeyValue.toString()) return '';

    if (strKeyValue.toString() == '' || strKeyValue.toString() == '-1') {

      return '';

    }

    else {

      let lst_Temp: any[] = lst_;

      lst_Temp = lst_Temp.filter((el) => { return el[strKey] == strKeyValue });

      return lst_Temp[0] ? lst_Temp[0][strComment] : ''

    }

  }

  // تغییر عنوان صفحه

  setTitle(newTitle: string) {

    this._tabTitle.setTitle(newTitle == '' ? 'تاکسی لون | درخواست تاکسی بین شهری راحت، سریع و ارزان' : newTitle);

  }

  // get user agent
  getUser_Agent() {

    if ('getBattery' in navigator) {

      (navigator as any).getBattery().then((battery: any) => {

        console.log(battery.level);

      });

    }

    else {
      console.log('Battery API is not supported on this browser.');
    }

    console.log(navigator.userAgent);

    console.log('-----------------------------------------------------');

    console.log(navigator.language)

    console.log('-----------------------------------------------------');

    console.log(navigator.platform)

    console.log('-----------------------------------------------------');

    console.log(navigator.appName)

  }

  markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.markAllAsTouched(control);
      }
    });
  }

  markAllAsUnTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsUntouched({ onlySelf: false });
      } else if (control instanceof FormGroup) {
        this.markAllAsUnTouched(control);
      }
    });
  }
}